import { useContext } from "react";
import { AuthContext } from "./AuthContext";

// Create the useAuth hook
/**
 * The `useAuth` function is a custom hook that returns the authentication context from the
 * `AuthContext` using the `useContext` hook.
 * @returns The `useAuth` function returns the `authContext` obtained from the `useContext` hook.
 * @example const { user, login, logout } = useAuth()
 */
export const useAuth = () => {
    const authContext = useContext(AuthContext);

    if (!authContext) {
        throw new Error("useAuth must be used within an AuthProvider");
    }

    return authContext;
};